import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowChevronLeft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.5977 3.29289C16.2072 2.90237 15.574 2.90237 15.1835 3.29289L7.2778 11.1986C6.83521 11.6412 6.8352 12.3588 7.2778 12.8014L15.1835 20.7071C15.574 21.0976 16.2072 21.0976 16.5977 20.7071C16.9883 20.3166 16.9883 19.6834 16.5977 19.2929L9.30484 12L16.5977 4.70711C16.9883 4.31658 16.9883 3.68342 16.5977 3.29289Z"
	})]
});
const ForwardRef = forwardRef(SvgArrowChevronLeft);
export { ForwardRef as ReactComponent };
